import ErrorIcon from '@mui/icons-material/Error';
import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

import InfoIcon from '@/assets/icons/InfoIcon';
import {
  FallbackUIInstructionStyles,
  FallbackUIMainStyles,
  FallbackUIMessageStyles,
  FallbackUIPaperStyles,
  FallbackUISeparatorStyles,
  FallbackUITitleStyles,
} from '@/errorHandling/fallbackUI/fallbackUi.styles.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';

type Props = {
  errorDetails: ReactNode;
  errorMessage: string | null;
};

export const FallbackUI: React.FC<Props> = props => {
  const { t } = useTranslationWithPrefix('components.fallbackUi');
  const { errorDetails, errorMessage } = props;

  if (
    import.meta.env.VITE_ENVIRONMENT !== 'local' &&
    errorMessage?.startsWith('error loading dynamically imported module')
  ) {
    window.location.reload();
    return null;
  }

  return (
    <Container maxWidth="lg" sx={FallbackUIMainStyles}>
      <Grid container spacing={4}>
        <Grid size={12}>
          <Paper sx={FallbackUIPaperStyles}>
            <Typography sx={FallbackUITitleStyles}>
              <ErrorIcon />
              {t('title')}
            </Typography>
            <Box sx={FallbackUISeparatorStyles}></Box>
            <Box
              sx={{
                mt: 2,
              }}
            >
              <Typography sx={FallbackUIMessageStyles}>{t('message')}</Typography>
              <code>{errorMessage}</code>
              <br />
              <code>{errorDetails}</code>
              <Typography sx={FallbackUIInstructionStyles}>
                <InfoIcon />
                {t('instruction', {
                  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL,
                })}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};
